module.exports = __webpack_public_path__ + "./images/2f324185d0494134734e458ccd763141.webp";